// PO-GST-01 · P2-D1-C-FIX01 · mirrors backend submit_po_for_approval eligibility exactly (display only).
const AUTH_OR_REJECTED = ["Rejected", "Approved", "Authorized", "Authorised"];

export function canSubmitPo(p) {
  const status = (p?.status || "").trim();
  const astat = (p?.approval_status || "").trim();
  const freshOpen = status === "Open" && (astat === "" || astat === "Not Submitted");
  const freshDraft = status === "Draft" && !AUTH_OR_REJECTED.includes(astat);
  const rejectedDraft = status === "Draft" && astat === "Rejected";
  return freshOpen || freshDraft || rejectedDraft;
}

export const isRejectedDraft = (p) => (p?.status || "").trim() === "Draft" && (p?.approval_status || "").trim() === "Rejected";

export const GRN_SUBMIT_WARNING = "This PO has historical GRN postings. Commercial amendments remain locked. Under the current approval rules, Management Reject is unavailable after submission. Proceed only if the PO is ready for authorization.";

export function submitConfirmText(p) {
  const verb = isRejectedDraft(p) ? "Resubmit" : "Submit";
  const base = `${verb} ${p.po_no} for Management Authorisation?\n\nOnce submitted the PO is locked for direct commercial edit until an Administrator authorises or rejects it via the Management Authorisation Queue.`;
  return p.has_posted_grn_history === true ? `${GRN_SUBMIT_WARNING}\n\n${verb} ${p.po_no} for Management Authorisation?` : base;
}

// REL-02 · backend refuses Submit once a GRN has been posted (Management Reject would be blocked).
export const GRN_SUBMIT_BLOCKED = "Submit for Authorisation is blocked — a GRN has been posted against this PO, so it can no longer enter the approval workflow.";
export const submitBlockedByGrn = (p) => canSubmitPo(p) && p?.has_posted_grn_history === true;
